import React from "react";

const ConditionalDivWrapper = ({wrapWithDiv, className, children}) => {
  if (wrapWithDiv) {
    return <div className={className}>
      {children}
    </div>
  } else {
    return <>
      {children}
    </>
  }
}

export default ConditionalDivWrapper